/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimerangeaspect8Inputs */

const de__class_datetimerangeaspect8 = /** @type {(inputs: _Class_Datetimerangeaspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist zwischen`)
};

/**

* @param {_Class_Datetimerangeaspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimerangeaspect8 = /** @type {((inputs?: _Class_Datetimerangeaspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimerangeaspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimerangeaspect8(inputs)
});
export { _class_datetimerangeaspect8 as "_class_DateTimeRANGEAspect" }